import {
  getAdminRouteByPath,
  type AdminRouteManifestEntry,
} from './adminRouteManifest';

export type AdminRouteAccessDecision =
  | { type: 'allow' }
  | { type: 'loading' }
  | { type: 'login' }
  | { type: 'forbidden' }
  | { type: 'diagnostic-disabled' };

export interface AdminRouteAccessInput {
  pathname: string;
  authLoading: boolean;
  hasCurrentUser: boolean;
  isAdmin: boolean;
  diagnosticsEnabled: boolean;
}

export function isAdminDiagnosticRoute(route: AdminRouteManifestEntry | undefined) {
  return route?.routeKind === 'diagnostic';
}

export function getAdminRouteAccessDecision({
  pathname,
  authLoading,
  hasCurrentUser,
  isAdmin,
  diagnosticsEnabled,
}: AdminRouteAccessInput): AdminRouteAccessDecision {
  if (authLoading) return { type: 'loading' };
  if (!hasCurrentUser) return { type: 'login' };
  if (!isAdmin) return { type: 'forbidden' };

  const route = getAdminRouteByPath(pathname);
  if (!route) return { type: 'forbidden' };

  if (isAdminDiagnosticRoute(route) && !diagnosticsEnabled) {
    return { type: 'diagnostic-disabled' };
  }

  return { type: 'allow' };
}
